/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
import { customElement } from 'solid-element';
import { ICustomElement } from 'component-register';
import FabButton, { FabButtonProps } from './FabButton';
import { BtnClasses } from '../../types/common';

// TypeScript declaration for the web component
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tc-fab-button': Partial<HTMLElement> &
        FabButtonProps &
        Partial<{ ref: ICustomElement }>;
    }
  }
}

export function defineSolidFabButton(): void {
  customElement(
    'tc-fab-button',
    {
      icon: '',
      btnClass: BtnClasses.PRIMARY,
      fabClass: 'fab-button',
      alwaysDisplay: false,
      disable: false,
      isToolTipDisabled: true,
    },
    FabButton
  );
}
